module.exports = __webpack_public_path__ + "img/booknow-btn.d3d43302.png";